import React from "react";
import { Modal, Button } from "antd";
import {
  EyeOutlined,
  DownloadOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import Files from "../../assets/img/files.png";
import moment from "moment";

interface ModalProps {
  isDownloadModalVisible: boolean;
  isPreviewModalVisible: boolean;
  handleDownloadModalCancel: () => void;
  handlePreviewModalCancel: () => void;
  handleOpenPreviewModal: () => void;
  processedFileURL: string;
  headerData: any;
  previewURL: string;
}

const DocumentModals: React.FC<ModalProps> = ({
  isDownloadModalVisible,
  isPreviewModalVisible,
  handleDownloadModalCancel,
  handlePreviewModalCancel,
  handleOpenPreviewModal,
  processedFileURL,
  headerData,
  previewURL,
}) => {
  const formattedDate = headerData?.date
    ? moment(headerData.date).format("MMMM Do YYYY, h:mm:ss a")
    : "";
  console.log("headerData", headerData);
  return (
    <>
      <Modal
        visible={isDownloadModalVisible}
        onCancel={handleDownloadModalCancel}
        footer={null}
        centered
        style={{ minWidth: "750px" }}
      >
        <div style={{}}>
          <div style={{ textAlign: "start" }}>
            <Button
              type="link"
              onClick={handleDownloadModalCancel}
              style={{ marginTop: "20px" }}
              className="go-back-button"
            >
              <ArrowLeftOutlined /> Go back
            </Button>
          </div>
          <h4
            style={{
              color: "#4A1C96",
              fontSize: "20px",
              fontFamily: "Poppins",
              textAlign: "center",
              marginBottom: "unset",
            }}
          >
            Your document is ready!
          </h4>
          <div
            style={{
              background: "#FAEEFF",
              border: "1px solid #FADCEA",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              padding: "24px",
              marginBottom: "1rem",
              marginTop: "1rem",
            }}
          >
            <h3
              style={{
                margin: "unset",
                color: "#4A1C96",
                fontSize: "18px",
                fontFamily: "Poppins",
                fontWeight: "600",
              }}
            >
              Your document has these data
            </h3>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <p style={{}}>Title</p>
              <span style={{ color: "#3A3737", fontWeight: "600" }}>
                {headerData?.title ?? ""}
              </span>
            </div>
            <div style={{ display: "flex", gap: "10rem" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <p>Processed at:</p>
                <span style={{ color: "#3A3737", fontWeight: "600" }}>
                  {formattedDate ?? ""}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <p style={{}}>Number of pages:</p>
                <span style={{ color: "#3A3737", fontWeight: "600" }}>
                  {headerData?.numPages ?? ""}
                </span>
              </div>
            </div>
          </div>

          <div
            style={{
              background: "#FAEEFF",
              border: "1px solid #FADCEA",
              borderRadius: "8px",
              padding: "1.5rem",
              marginBottom: "1rem",
              textAlign: "left",
            }}
          >
            <h4
              style={{
                margin: "unset",
                color: "#4A1C96",
                fontSize: "18px",
                fontFamily: "Poppins",
                fontWeight: "600",
              }}
            >
              Text Preprocessing Options:
            </h4>
            <div
              style={{
                marginBottom: "1rem",
                fontFamily: "Poppins",
                fontSize: "14px",
              }}
            >
              <p>
                Summary included:{" "}
                <span style={{ color: "#3A3737", fontWeight: "600" }}>
                  {headerData.summaryIncluded ? "Yes" : "No"}
                </span>
              </p>
              <p>
                Tokenization type:{" "}
                <span style={{ color: "#3A3737", fontWeight: "600" }}>
                  {headerData?.tokenizationType ?? ""}
                </span>
              </p>
              <p>
                Word count:{" "}
                <span style={{ color: "#3A3737", fontWeight: "600" }}>
                  {headerData?.wordCount ?? ""}
                </span>
              </p>

              <p>
                Sentiment:{" "}
                <span style={{ color: "#3A3737", fontWeight: "600" }}>
                  {headerData.sentiment}
                </span>
              </p>
              <div>
                <h4>Readability Analysis</h4>
                <p>
                  Flesch Reading Score:{" "}
                  <span style={{ color: "#3A3737", fontWeight: "600" }}>
                    {headerData?.readability?.fleschReadingScore ?? ""}
                  </span>
                </p>
                <p>
                  Gunning Fog Index:{" "}
                  <span style={{ color: "#3A3737", fontWeight: "600" }}>
                    {headerData?.readability?.gunningFogIndex ?? ""}
                  </span>
                </p>
                <p>
                  SMOG Index:{" "}
                  <span style={{ color: "#3A3737", fontWeight: "600" }}>
                    {headerData?.readability?.smogIndex ?? ""}
                  </span>
                </p>
              </div>
              <div>
                <h4>Entities</h4>
                {headerData?.entities?.length > 0 ? (
                  <ul>
                    {headerData.entities.map((entity: any, index: any) => (
                      <li key={index}>{JSON.stringify(entity)}</li>
                    ))}
                  </ul>
                ) : (
                  <p>No entities extracted</p>
                )}
              </div>
            </div>
          </div>
          <div
            style={{
              background: "#F4D9FF",
              marginBottom: "2rem",
              padding: "1px 10px",
              borderRadius: "8px",
            }}
          >
            <p style={{ color: "#4A1C96", padding: "8px 0" }}>
              Note: Your document has been <strong>processed!</strong> You can
              preview or download it on the buttons below.
            </p>
          </div>
          <div className="preview-download-div">
            <Button
              href={processedFileURL} // Keep if necessary for a fallback
              target="_blank"
              onClick={(e) => {
                e.preventDefault();
                handleOpenPreviewModal();
              }}
              style={{ marginRight: "10px" }}
              className="prev-button"
            >
              <EyeOutlined /> Preview
            </Button>

            <Button
              href={processedFileURL}
              download="processedFile.docx"
              className="process-button"
            >
              <DownloadOutlined /> Download
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        title="Preview Document"
        visible={isPreviewModalVisible}
        onCancel={handlePreviewModalCancel}
        footer={null}
        width={800}
      >
        {previewURL ? (
          // Use an iframe to preview the document using Google Docs Viewer
          <iframe
            src={previewURL}
            style={{ width: "100%", height: "600px" }}
            frameBorder="0"
            allowFullScreen
          />
        ) : (
          <p>Preview not available for this file type.</p>
        )}
      </Modal>
    </>
  );
};

export default DocumentModals;
